import React from 'react';

import { Form, Modal } from 'antd';
import { t } from 'i18next';

import { useNotification } from 'segments/hooks/useNotification';

import { InputStr, SubmiteButton } from 'shared/FormItems';
import { ModalFooter } from 'shared/Modals';

import { CreateCourtParams, useCreateCourtMutation, SelectCourtSurface, SelectCourtType } from 'features/courts';
import { SelectImage } from 'features/imagesStore';
import { SelectTimePrice } from 'features/timesPrice';

type FormData = CreateCourtParams;

interface Props {
  isModalOpen: boolean;
  handleCancel: () => void;
}

const initialValues = {
  surfaceType: 'clay',
  type: 'indoor',
};

const CreateCourtModal = ({ isModalOpen, handleCancel }: Props) => {
  const [form] = Form.useForm<FormData>();
  const [create, { isSuccess, isError, isLoading, error }] = useCreateCourtMutation();


  useNotification({
    isSuccess,
    isError,
    onSuccess: () => handleCancel(),
    onError: () => handleCancel(),
    error
  });

  const onFinish = (values: FormData) => {
    create(values);
  };

  return (
    <Modal
      title={t('courts.title.create')}
      open={isModalOpen}
      onCancel={handleCancel}
      destroyOnClose
      footer={[
        <ModalFooter
          key="modalFooter"
          handleCancel={handleCancel}
          resetFields={form.resetFields}
        />
      ]}
    >
      <Form
        name="basic"
        layout="vertical"
        form={form}
        onFinish={onFinish}
        autoComplete="off"
        initialValues={initialValues}
        className="edit-user__form"
      >
        <InputStr type='name' formProps={{ rules: [{ required: true }] }} />
        <SelectCourtSurface />
        <SelectCourtType />
        <SelectImage />
        <SelectTimePrice<FormData> formProps={{ form }} />
        <SubmiteButton submiteText={t('table.create')} isLoading={isLoading} />
      </Form>
    </Modal>
  );
};

export default CreateCourtModal;
